<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
  </div>
  <div class="row">
    <section class="col-12" id="firstSection">
      <div class="card" [ngClass]="activeTab === 'firstSection' ? ' pb-0' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('firstSection')">
          <h3>{{ "COST_INDETERMINATE_DETERMINATE" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'firstSection' ? 'card-body p-0 pt-1' : 'd-none'">
          <ngx-datatable
            class="bootstrap core-bootstrap w-100"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 50 : 300"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filteredIndeterminateList"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'LEVEL' | translate" prop="level" *ngIf="_utilService.isDesktop" [width]="80">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.level }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'SALARY_YEARLY_GROSS' | translate" prop="salary_yearly_gross" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ _utilService.addDotsToNumber(row.salary_yearly_gross) }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'BONUS' | translate" prop="bonus" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <span class="mb-0 mr-075" *ngIf="!row.edit_line">{{ _utilService.addDotsToNumber(row.bonus) }}</span>
                  <input type="text" class="form-control bonus-input mr-075" [(ngModel)]="row.bonus" (change)="formatBonusValue(row)" *ngIf="row.edit_line" />
                  <span class="cursor-pointer" *ngIf="!row.edit_line" (click)="row.edit_line = !row.edit_line"><i class="text-primary mr-075" data-feather="edit-2" size="15"></i></span>
                  <span class="cursor-pointer" *ngIf="row.edit_line && row.bonus !== '0.00' && row.bonus != '0.0'" (click)="calculateBonus(row, 'indeterminate')"
                    ><i class="text-success mr-075" data-feather="check" size="20"></i
                  ></span>
                  <span class="cursor-pointer" *ngIf="row.edit_line && row.bonus !== '0.00' && row.bonus != '0.0'" (click)="resetBonus(row, 'indeterminate')"><i class="text-danger" data-feather="x" size="20"></i></span>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!-- TODO: Vedere con paolo e gigi se inserire queste due colonne -->

            <!--<ngx-datatable-column [name]="'TOTAL_YEARLY' | translate" prop="total_yearly" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <p>{{ row.total_yearly }}</p>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TOTAL_MONTH' | translate" prop="total_month" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <p>{{ row.total_month }}</p>
              </ng-template>
            </ngx-datatable-column>-->
            <ngx-datatable-column [name]="'NET_MONTHLY_12' | translate" prop="net_monthly_12" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ _utilService.addDotsToNumber(row.net_monthly_12) }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'NET_MONTHLY_13' | translate" prop="net_monthly_13" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ _utilService.addDotsToNumber(row.net_monthly_13) }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TOTAL_DAILY' | translate" prop="total_daily" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ _utilService.addDotsToNumber(row.total_daily) }}</span>
              </ng-template>
            </ngx-datatable-column>

            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'NAME' | translate" prop="level" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <p>{{ "LEVEL" | translate }}: {{ row.level }}</p>
                  </div>
                  <div class="col-12">
                    <p>{{ "SALARY_YEARLY_GROSS" | translate }}: {{ row.salary_yearly_gross }}</p>
                  </div>
                  <div class="col-12 d-flex align-items-center">
                    <p class="mr-075" *ngIf="!row.edit_line">{{ "BONUS" | translate }}: {{ row.bonus }}</p>
                    <input type="text" class="form-control bonus-input mr-075" [(ngModel)]="row.bonus" (change)="formatBonusValue(row)" *ngIf="row.edit_line" />
                    <span class="cursor-pointer mb-1" *ngIf="!row.edit_line" (click)="row.edit_line = !row.edit_line"><i class="text-primary mr-075" data-feather="edit-2" size="15"></i></span>
                    <span class="cursor-pointer" *ngIf="row.edit_line && row.bonus !== '0.00' && row.bonus != '0.0'" (click)="calculateBonus(row, 'indeterminate')"
                      ><i class="text-success mr-075" data-feather="check" size="20"></i
                    ></span>
                    <span class="cursor-pointer" *ngIf="row.edit_line && row.bonus !== '0.00' && row.bonus != '0.0'" (click)="resetBonus(row, 'indeterminate')"
                      ><i class="text-danger" data-feather="x" size="20"></i
                    ></span>
                  </div>
                  <div class="col-12">
                    <p>{{ "TOTAL_YEARLY" | translate }}: {{ row.total_yearly }}</p>
                  </div>
                  <div class="col-12">
                    <p>{{ "TOTAL_MONTH" | translate }}: {{ row.total_month }}</p>
                  </div>
                  <div class="col-12">
                    <p>{{ "NET_MONTHLY_12" | translate }}: {{ row.net_monthly_12 }}</p>
                  </div>
                  <div class="col-12">
                    <p>{{ "NET_MONTHLY_13" | translate }}: {{ row.net_monthly_13 }}</p>
                  </div>
                  <div class="col-12">
                    <p>{{ "TOTAL_DAILY" | translate }}: {{ row.total_daily }}</p>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>

    <section class="col-12" id="secondSection">
      <div class="card" [ngClass]="activeTab === 'secondSection' ? 'active pb-0' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('secondSection')">
          <h3>{{ "COST__APPRENTICESHIP" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'secondSection' ? 'card-body p-0 pt-1' : 'd-none'">
          <ngx-datatable
            class="bootstrap core-bootstrap w-100"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 50 : 300"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filteredApprenticeshipList"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          >
            <ngx-datatable-column [name]="'LEVEL' | translate" prop="level" *ngIf="_utilService.isDesktop" [width]="90">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.level }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'YEAR' | translate" prop="year" *ngIf="_utilService.isDesktop" [width]="90">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.year }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'SALARY_YEARLY_GROSS' | translate" prop="salary_yearly_gross" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ _utilService.addDotsToNumber(row.salary_yearly_gross) }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'BONUS' | translate" prop="bonus" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <span class="mb-0 mr-075" *ngIf="!row.edit_line">{{ _utilService.addDotsToNumber(row.bonus) }}</span>
                  <input type="text" class="form-control bonus-input mr-075" [(ngModel)]="row.bonus" (change)="formatBonusValue(row)" *ngIf="row.edit_line" />
                  <span class="cursor-pointer" *ngIf="!row.edit_line" (click)="row.edit_line = !row.edit_line"><i class="text-primary mr-075" data-feather="edit-2" size="15"></i></span>
                  <span class="cursor-pointer" *ngIf="row.edit_line && row.bonus !== '0.00' && row.bonus != '0.0'" (click)="calculateBonus(row, 'apprenticeship')"
                    ><i class="text-success mr-075" data-feather="check" size="20"></i
                  ></span>
                  <span class="cursor-pointer" *ngIf="row.edit_line && row.bonus !== '0.00' && row.bonus != '0.0'" (click)="resetBonus(row, 'apprenticeship')"><i class="text-danger" data-feather="x" size="20"></i></span>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!--<ngx-datatable-column [name]="'TOTAL_YEARLY' | translate" prop="total_yearly" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <p>{{ row.total_yearly }}</p>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TOTAL_MONTH' | translate" prop="total_month" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <p>{{ row.total_month }}</p>
              </ng-template>
            </ngx-datatable-column>-->
            <ngx-datatable-column [name]="'NET_MONTHLY_12' | translate" prop="net_monthly_12" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ _utilService.addDotsToNumber(row.net_monthly_12) }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'NET_MONTHLY_13' | translate" prop="net_monthly_13" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ _utilService.addDotsToNumber(row.net_monthly_13) }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TOTAL_DAILY' | translate" prop="total_daily" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ _utilService.addDotsToNumber(row.total_daily) }}</span>
              </ng-template>
            </ngx-datatable-column>

            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'NAME' | translate" prop="level" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <span>{{ "LEVEL" | translate }}: {{ row.level }}</span>
                  </div>
                  <div class="col-12">
                    <span>{{ "SALARY_YEARLY_GROSS" | translate }}: {{ row.salary_yearly_gross }}</span>
                  </div>
                  <div class="col-12 d-flex align-items-center">
                    <span class="mr-075" *ngIf="!row.edit_line">{{ "BONUS" | translate }}: {{ row.bonus }}</span>
                    <input type="text" class="form-control bonus-input mr-075" [(ngModel)]="row.bonus" (change)="formatBonusValue(row)" *ngIf="row.edit_line" />
                    <span class="cursor-pointer mb-1" *ngIf="!row.edit_line" (click)="row.edit_line = !row.edit_line"><i class="text-primary mr-075" data-feather="edit-2" size="15"></i></span>
                    <span class="cursor-pointer" *ngIf="row.edit_line && row.bonus !== '0.00' && row.bonus != '0.0'" (click)="calculateBonus(row, 'apprenticeship')"
                      ><i class="text-success mr-075" data-feather="check" size="20"></i
                    ></span>
                    <span class="cursor-pointer" *ngIf="row.edit_line && row.bonus !== '0.00' && row.bonus != '0.0'" (click)="resetBonus(row, 'apprenticeship')"
                      ><i class="text-danger" data-feather="x" size="20"></i
                    ></span>
                  </div>
                  <div class="col-12">
                    <span>{{ "TOTAL_YEARLY" | translate }}: {{ row.total_yearly }}</span>
                  </div>
                  <div class="col-12">
                    <span>{{ "TOTAL_MONTH" | translate }}: {{ row.total_month }}</span>
                  </div>
                  <div class="col-12">
                    <span>{{ "NET_MONTHLY_12" | translate }}: {{ row.net_monthly_12 }}</span>
                  </div>
                  <div class="col-12">
                    <span>{{ "NET_MONTHLY_13" | translate }}: {{ row.net_monthly_13 }}</span>
                  </div>
                  <div class="col-12">
                    <span>{{ "TOTAL_DAILY" | translate }}: {{ row.total_daily }}</span>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>

    <section class="col-12" id="thirdSection">
      <div class="card" [ngClass]="activeTab === 'thirdSection' ? 'active pb-0' : ''">
        <div class="card-title px-2 mb-0" (click)="changeTab('thirdSection')">
          <h3>{{ "CALCULATE_COST" | translate }}</h3>
        </div>
        <div [ngClass]="activeTab === 'thirdSection' ? 'card-body' : 'd-none'">
          <div class="row">
            <div class="col-lg-3 col-12 form-group">
              <label for="type">{{ "TYPE" | translate }}: </label>
              <ng-select id="type" [(ngModel)]="selectedType">
                <ng-option value="indeterminate">{{ "INDETERMINATE" | translate }}</ng-option>
                <ng-option value="apprenticeship">{{ "APPRENTICESHIP" | translate }}</ng-option>
              </ng-select>
            </div>
            <div class="col-lg-3 col-12 form-group">
              <label for="salary_yearly_gross">{{ "BONUS" | translate }}: </label>
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text">&euro;</span>
                </div>
                <input class="form-control" id="bonus" type="text" [(ngModel)]="bonus" (change)="formatMoney('bonus')" />
              </div>
            </div>
            <div class="col-lg-3 col-12 form-group">
              <label for="salary_yearly_gross">{{ "SALARY_YEARLY_GROSS" | translate }}: </label>
              <div class="input-group input-group-merge">
                <div class="input-group-prepend">
                  <span class="input-group-text">&euro;</span>
                </div>
                <input class="form-control" id="salary_yearly_gross" type="text" [(ngModel)]="ral" (change)="formatMoney('ral')" />
              </div>
            </div>
            <div class="col-lg-1 col-12 d-flex align-items-center mt-075">
              <button class="btn btn-primary" (click)="calculateCost()" [disabled]="!ral || ral === '0,00' || !selectedType">{{ "CALCULATE" | translate }}</button>
            </div>
          </div>
          <div class="row mt-3" *ngIf="calculatedContract">
            <div class="col-12">
              <h2>
                {{ "COST_GENERATED_CONTRACT" | translate }}
              </h2>
            </div>
            <div class="form-group col-lg-1 col-12">
              <div class="font-weight-bold">{{ "LEVEL" | translate }}:</div>
              <div>{{ calculatedContract.level }}</div>
            </div>
            <div class="form-group col-lg-2 col-12">
              <div class="font-weight-bold">{{ "SALARY_YEARLY_GROSS" | translate }}:</div>
              <div>{{ calculatedContract.salary_yearly_gross }} €</div>
            </div>
            <div class="form-group col-lg-2 col-12">
              <div class="font-weight-bold">{{ "TOTAL_YEARLY" | translate }}:</div>
              <div>{{ calculatedContract.total_yearly }} €</div>
            </div>
            <div class="form-group col-lg-2 col-12">
              <div class="font-weight-bold">{{ "TOTAL_MONTH" | translate }}:</div>
              <div>{{ calculatedContract.total_month }} €</div>
            </div>
            <div class="form-group col-lg-2 col-12">
              <div class="font-weight-bold">{{ "NET_MONTHLY_12" | translate }}:</div>
              <div>{{ calculatedContract.net_monthly_12 }} €</div>
            </div>
            <div class="form-group col-lg-2 col-12">
              <div class="font-weight-bold">{{ "NET_MONTHLY_13" | translate }}:</div>
              <div>{{ calculatedContract.net_monthly_13 }} €</div>
            </div>
            <div class="col-lg-1 col-12">
              <div class="font-weight-bold">{{ "TOTAL_DAILY" | translate }}:</div>
              <div>{{ calculatedContract.total_daily }} €</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
